import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {hideSideBar} from '../../redux/actions/miscActions'

export class SideBarNavLinks extends Component {
  handleLinkClick=(link)=>{
    this.props.history.push(`/${link}`)
    this.props.hideSideBar()
  }

  render() {
    return (
      <div>
        <p className="link" onClick={()=>this.handleLinkClick('pakketten')}>
          Pakketten <i className="fas fa-angle-right"></i>
        </p>
        
          <p className="link" onClick={()=>this.handleLinkClick('')}>
          Zelf samenstellen <i className="fas fa-angle-right"></i>
        </p>
      </div>
    )
  }
}


const mapStateToProps = (state) => ({
  misc: state.misc
})

export default connect(mapStateToProps, {hideSideBar})(withRouter(SideBarNavLinks))
